import { render } from "./TheHeroPanel.vue?vue&type=template&id=ce4dceca&scoped=true"
import script from "./TheHeroPanel.vue?vue&type=script&lang=js"
export * from "./TheHeroPanel.vue?vue&type=script&lang=js"

import "./TheHeroPanel.vue?vue&type=style&index=0&id=ce4dceca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ce4dceca"

export default script